export default {
  "base": "list-disc ps-6 my-5 marker:text-(--ui-border-accented)"
}